import { GateNandIcon } from './GateNandIcon';

/**
 * author: Nick
 * id FF2BA1EF-7AAE-4271-B799-6A51FE84427E
 * name gate-nand
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-nand.svg
 * tags
 */
export const LogicGateNandIcon = GateNandIcon;
export default LogicGateNandIcon